import React from "react";

export const PageNotFoundPage = () => {
  return (
    <>
      <h1>Page Not Found</h1>
    </>
  );
}
